export const dataTypesActionTypes = {
  SET_NUMERIC_FEATURES: "SET_NUMERIC_FEATURES",
  SET_CATEGORICAL_FEATURES: "SET_CATEGORICAL_FEATURES",
  SET_DATE_FEATURES: "SET_DATE_FEATURES",
  SET_TEXT_FEATURES: "SET_TEXT_FEATURES",
  SET_KEEP_FEATURES: "SET_KEEP_FEATURES",
  SET_IGNORED_FEATURES: "SET_IGNORED_FEATURES",
  SET_SELECTED_FEATURES: "SET_SELECTED_FEATURES",
  RESET_DATATYPES_DATA: "RESET_DATATYPES_DATA",
  SET_ORDINAL_FEATURE: "SET_ORDINAL_FEATURE",
  SET_ORDINAL_FEATURES_ORDER: "SET_ORDINAL_FEATURES_ORDER",
};
